export default __webpack_public_path__ + "static/media/mint-gen-2.2a9d41d6.png";